// @flow

import * as React from "react";

import Accordion from "../molecules/Accordion";
import SectionHeader from "../molecules/SectionHeader";

type PropsType = {
    accordions?: [any],
    title?: string | React.Node,
    description?: string,
};

const Accordions = (props: PropsType): React.Node => {
    return (
        <div className="accordions">
            {props.title || props.description ? (
                <SectionHeader
                    sectionName="accordions"
                    title={props.title}
                    description={props.description}
                />
            ) : null}
            <div className="accordions__content">
                {props.accordions &&
                    props.accordions.map(
                        (accordion: any, index: number): React.Node => (
                            <Accordion key={index} {...accordion} />
                        )
                    )}
            </div>
        </div>
    );
};

export default Accordions;
